"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditorRenderer = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_pages_1 = require("@opsbase/lib-pages");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const App_1 = __importDefault(require("@opsbase/lib-system/App"));
const Features_1 = require("@opsbase/lib-system/Features");
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const PreviewIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PreviewIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const SidePane_1 = __importDefault(require("@opsbase/web-ui/SidePane"));
const SidePaneStack_1 = __importDefault(require("@opsbase/web-ui/SidePane/SidePaneStack"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedSelect_1 = __importDefault(require("../FedController/useFedSelect"));
const useFedSetup_1 = __importDefault(require("../FedController/useFedSetup"));
const Preview_1 = __importDefault(require("../Preview"));
const QuestionBank_1 = __importDefault(require("../QuestionBank"));
const QuestionEditor_1 = __importDefault(require("../QuestionEditor"));
const QuestionTree_1 = __importDefault(require("../QuestionTree"));
const FormEditorHeader_1 = __importDefault(require("./FormEditorHeader"));
const makeMyClasses = () => ({
    container: {
        overflow: 'hidden',
        height: '100%',
    },
});
const DotsPane = () => {
    return react_1.default.createElement(Dots_1.default, { color: lib_palette_1.default.primary, style: { margin: '40px auto' } });
};
function FormEditorRenderer() {
    const { selected, fullySelected } = (0, useFedSelect_1.default)();
    const { mode, isQuestionSet, id } = (0, useFedSetup_1.default)();
    const { doSetTreeFocus } = (0, useFedActions_1.default)();
    const rootRef = (0, react_1.useRef)();
    const editMode = mode === 'edit';
    const hasChanged = selected !== fullySelected;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleFocusTree = (0, useCallforward_1.default)(v => () => doSetTreeFocus(v), [doSetTreeFocus]);
    const { isAlt } = (0, useSysLang_1.default)();
    const { openTo } = (0, useNav_1.default)();
    const handleOpenPreview = (0, react_1.useCallback)(() => {
        openTo(lib_pages_1.Pages.OP_PREVIEW, { id });
    }, [openTo, id]);
    const renderOpenDetails = (0, react_1.useMemo)(() => () => react_1.default.createElement(QuestionEditor_1.default, null), []);
    const renderOpenQSets = (0, react_1.useMemo)(() => () => react_1.default.createElement(QuestionBank_1.default, null), []);
    const renderPreview = (0, react_1.useMemo)(() => () => {
        const footNote = isAlt ? (react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true, padding: true },
            react_1.default.createElement(IconButton_1.default, { tooltip: lib_i18n_1.default.t('open-preview'), noOpacity: true, icon: react_1.default.createElement(PreviewIcon_1.default, { size: 24, color: lib_palette_1.default.primary }), onClick: handleOpenPreview }),
            react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('lang-new-window')))) : undefined;
        return react_1.default.createElement(Preview_1.default, { highlightSelected: true, footNote: footNote });
    }, [handleOpenPreview, isAlt]);
    (0, react_1.useEffect)(() => {
        if (hasChanged)
            rootRef.current.focus();
    }, [hasChanged]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Vertical_1.default, null,
        editMode && react_1.default.createElement(FormEditorHeader_1.default, null),
        react_1.default.createElement(Horizontal_1.default, { ref: rootRef, classes: { root: myCss.container } },
            react_1.default.createElement(SidePane_1.default, { label: lib_i18n_1.default.t('preview'), width: 420, left: true, startOpen: !editMode, renderOpening: DotsPane, renderOpen: renderPreview }),
            react_1.default.createElement(Pane_1.default, { grow: true, onMouseEnter: handleFocusTree(true), onMouseLeave: handleFocusTree(false) },
                react_1.default.createElement(QuestionTree_1.default, null)),
            editMode && (react_1.default.createElement(SidePaneStack_1.default, { sidePanes: [
                    {
                        label: lib_i18n_1.default.t('details'),
                        width: 350,
                        startOpen: editMode,
                        renderOpening: DotsPane,
                        renderOpen: renderOpenDetails,
                    },
                    !isQuestionSet && {
                        flag: Features_1.FeatureSets[App_1.default.OPSBASE].QUESTIONBANK.key,
                        label: lib_i18n_1.default.t('question-bank'),
                        width: 350,
                        startOpen: false,
                        renderOpening: DotsPane,
                        renderOpen: renderOpenQSets,
                    },
                ] }))))), [
        editMode,
        myCss.container,
        renderPreview,
        handleFocusTree,
        renderOpenDetails,
        isQuestionSet,
        renderOpenQSets,
    ]);
}
exports.FormEditorRenderer = FormEditorRenderer;
exports.default = FormEditorRenderer;
